
    import "src/app/AppSeller/Orders/components/index.module.scss?farm_css_modules";
    
    export default {"childDiv": `childDiv-95803bc5`,"modalParentDiv": `modalParentDiv-95803bc5`}
    